/**
 * 결제 관련 에러를 사용자 친화적인 메시지로 변환하는 유틸리티 함수
 * 
 * @param error 발생한 에러 객체
 * @returns 사용자에게 표시할 친화적인 에러 메시지
 */
export function getPaymentErrorMessage(error: unknown): string {
  if (!(error instanceof Error)) {
    return '결제 처리 중 오류가 발생했습니다.';
  }

  const errorMessage = error.message;

  // 사용자 취소 관련 메시지
  if (
    errorMessage.includes('사용자가 결제를 취소') || 
    errorMessage.includes('창이 닫혔습니다') ||
    errorMessage.includes('카드 등록 중 오류가 발생했습니다') ||
    errorMessage.includes('결제창이 닫혔습니다')
  ) {
    return '결제가 취소되었습니다.';
  }

  // PortOne API 에러 타입별 메시지
  if (errorMessage.includes('MAX_TRANSACTION_COUNT_REACHED')) {
    return '카드 결제 시도 횟수가 초과되었습니다. 잠시 후 다시 시도해주세요.';
  }
  
  if (errorMessage.includes('BILLING_KEY_NOT_FOUND')) {
    return '등록된 카드 정보를 찾을 수 없습니다. 카드를 다시 등록해주세요.';
  }
  
  if (errorMessage.includes('BILLING_KEY_ALREADY_DELETED')) {
    return '등록된 카드 정보가 이미 삭제되었습니다. 카드를 다시 등록해주세요.';
  }
  
  if (errorMessage.includes('PG_PROVIDER')) {
    return '카드사에서 결제가 거부되었습니다. 다른 카드로 시도하거나 카드사에 문의해주세요.';
  }
  
  if (errorMessage.includes('ALREADY_PAID')) {
    return '이미 결제가 완료된 거래입니다.';
  }
  
  if (errorMessage.includes('FORBIDDEN')) {
    return '결제가 거부되었습니다. 카드 정보를 확인해주세요.';
  }

  // 그 외 에러는 원본 메시지 반환
  return errorMessage;
}

/**
 * 사용자 취소 관련 에러인지 확인하는 함수
 * 사용자 취소는 에러 표시가 필요 없는 경우에 사용
 * 
 * @param error 발생한 에러 객체
 * @returns 사용자 취소 에러인지 여부
 */
export function isUserCancelError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  // UserCancelError인 경우 바로 true 반환
  if (error.name === 'UserCancelError') {
    return true;
  }
  
  const errorMessage = error.message;
  
  // 사용자 취소와 관련된 메시지가 포함된 경우
  return (
    errorMessage.includes('PAY_PROCESS_CANCELED') ||
    errorMessage.includes('사용자가 결제를 취소') || 
    errorMessage.includes('창이 닫혔습니다') ||
    errorMessage.includes('카드 등록 중 오류가 발생했습니다') ||
    errorMessage.includes('결제창이 닫혔습니다')
  );
} 